import consts from './consts';
import Store from "$common/utils/store";
import { enumsAllGet as enumsAllGetApi } from "$merChantApi/marketzone-boss";

export default {
  // 获取全局枚举
  async getEnumByKeys({ commit }) {
    if (process?.env?.NODE_ENV === 'development') {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        const localEnums = Store.loadObject('enums');
        if (localEnums) {
          commit(consts.GET_ENUMBYKEYS, localEnums)
          // 把全局枚举的值对应放到其他模块下
          // 此处是兼容旧版本的store模块管理枚举架构
          const stateModulesMap = $vm.$store.state
          // 因为后台的模块名与前端的模块名不一致,做个中间map用于转换
          const mdNameMap = {
            settle: 'settle',
            order: 'trade'
          }
          Object.keys(localEnums).forEach(mdName => {
            if (stateModulesMap[mdNameMap[mdName] || mdName]) {
              commit(mdName + '/setEnumStatus', localEnums[mdName], {
                root: true
              })
            }
          })
        }
      }, 0);
    }
    let rspCd, data;
    const { enums } = Vue.prototype.ssr;
    if (enums) {
      rspCd = enums.rspCd;
      data = enums.data;
    } else {
      const res = await enumsAllGetApi({});
      rspCd = res.rspCd;
      data = res.data;
    }
    if (rspCd === '00000') {
      if (process?.env?.NODE_ENV === 'development') {
        Store.saveObject('enums', data);
      }
      commit(consts.GET_ENUMBYKEYS, data)
      // 把全局枚举的值对应放到其他模块下
      // 此处是兼容旧版本的store模块管理枚举架构
      const stateModulesMap = $vm.$store.state
      // 因为后台的模块名与前端的模块名不一致,做个中间map用于转换
      const mdNameMap = {
        settle: 'settle',
        order: 'trade'
      }
      Object.keys(data).forEach(mdName => {
        if (stateModulesMap[mdNameMap[mdName] || mdName]) {
          commit(mdName + '/setEnumStatus', data[mdName], {
            root: true
          })
        }
      })
    }
  }
}
